import { AnswerDoctorCommunication } from 'domain/usecases/surgical-pendency/answer-doctor-communication'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteAnswerDoctorCommunication
  implements AnswerDoctorCommunication
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}

  async answer(
    params: AnswerDoctorCommunication.Params
  ): Promise<AnswerDoctorCommunication.Model> {
    return this.surgicalPendencyRepository.answerDoctorCommunication(params)
  }
}
